import styled from 'styled-components';

import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';
import { QuickLinkCards } from '@telialt/core-cms-content/src/components/BlockQuickLink/QuickLinkCards';

export const QuickLinkCardsSection = styled(QuickLinkCards).attrs({ role: 'complementary' })`
    background: ${getPurpurColor('backgroundSecondary')};
`;
